<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <tg-dropdown :items="dropdown" @on-change="handleChange" trigger="click">
          <template slot="icon">
            <i class="tg-icon tg-icon-save"></i>
          </template>
        </tg-dropdown>
        <tg-date-search ref="dateSearch" size="small" v-model="dateRange"></tg-date-search>
        <el-input
          :placeholder="$t('component.form.input.placeholder.member')"
          v-model="searchData.targetName"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>
      <tg-amount-bar ref="amount" v-if="showAmount" :columns="amountColumns" :row="amountData"></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      :filterMethods="filterMethods"
      @on-loaded="handleLoaded"
      @filter-change="remoteFilter"
      :summary-method="parsePageSummary"
      showSummary
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name v-bind="scope"></tg-user-full-name>
      </template>

      <template slot="step" slot-scope="scope">{{$t('component.dropdown.step[' +scope.value+ ']')}}</template>
      <template
        slot="action"
        slot-scope="scope"
      >{{$t('component.dropdown.finance[' + scope.value + ']')}}</template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import { summary } from "@/utils/table";

import apis from "@/apis";
const api = apis.accounts.transfer;

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDropdown,
    TgDateSearch,
    TgAmountBar,
    TgTable,
    TgUserFullName,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      amountData: {},
      amountPageData: {},
      amountColumns: [],
      showAmount: false,
      dateRange: {},
      searchData: {
        targetName: "",
        type: 1,
        note: null,
        step: null,
      },
      dropdown: [],
      // 存提款
      selected: null,
      filterMethods: {
        step: this.handleFilter,
      },
      rechargeFilters: [],
      withdrawalFilters: [],
    };
  },
  computed: {
    headerHeight() {
      return !this.showAmount ? 80 : 140;
    },
    request() {
      return { ...this.searchData, ...this.dateRange };
    },
    stepFilter() {
      return [1, 2, 3, 4, 5, 6].map((item) => {
        return {
          text: this.$t("component.dropdown.step[" + item + "]"),
          value: item,
        };
      });
    },
    saveby_type_icons() {
      let arr = this.rechargeFilters.concat(this.withdrawalFilters);

      return arr.reduce((a, c) => {
        a[c.id] = c.icon;
        return a;
      }, {})
    },
    parsePageSummary() {
      let data = this.amountPageData ? [this.amountPageData] : [];

      return () => {
        return summary(
          this.columns,
          data,
          this.$t("component.table.summary"),
          0
        );
      };
    },
  },
  created() {
    api.getColumns().then((response) => {
      this.rechargeFilters = response.data.rechargeFilters;
      this.withdrawalFilters = response.data.withdrawalFilters;

      let columns = response.data.columns;
      // let saveByFilter = columns.findIndex(x => x.name == 'saveBy');
      // columns[saveByFilter].filters = response.data.rechargeFilters;
      // columns[saveByFilter]["filter-multiple"] = false;

      // let noteFilter = columns.findIndex(x => x.name == 'note');
      // columns[noteFilter].filters = [];
      // columns[noteFilter]["filter-multiple"] = false;

      let stepFilter = columns.findIndex(x => x.name == 'step');
      columns[stepFilter].filters = this.stepFilter;
      columns[stepFilter]["filter-multiple"] = false;
      this.columns = columns;
      
      this.amountColumns = response.data.amountColumns;
      // this.amountColumns[0]['name'] = "total_requst_amount";
      this.dropdown = this.parseDropdown(response.data.dropdown);
      this.$nextTick(() => {
        this.$refs.table.init(this.request);
      });
    });
  },
  methods: {
    handleSearch() {
      this.$refs.table.search(this.request);
    },
    handleChange(item) {
      this.selected = item;
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        this.showAmount =
          !("length" in response.amount_data) && response.data.length > 0;

        this.amountPageData = response.amountPageData;
        this.amountData = response.amount_data;

        let columns = JSON.parse(JSON.stringify(this.columns));

        // let saveByFilter = columns.findIndex(x => x.name == 'saveBy');
        // if(this.selected != null){          
        //   columns[saveByFilter].filters = this.selected.value == 1 ? this.rechargeFilters : this.withdrawalFilters;
        // }
        // columns[saveByFilter]["filter-multiple"] = false;

        let noteFilter = columns.findIndex(x => x.name == 'note');
        if(response.note_available.length > 0){
          columns[noteFilter].filters = response.note_available.map((item) => {
            return {
              text: item.text,
              value: item.keys,
            };
          });
        }
        columns[noteFilter]["filter-multiple"] = false;

        this.columns = columns;
      }
    },
    parseDropdown(dropdown) {
      return dropdown.map((item) => {
        return {
          label: this.$t("component.dropdown.finance[" + item + "]"),
          value: item,
        };
      });
    },
    handleFilter() {
      return true;
    },
    remoteFilter(filters) {
      for (let k in filters) {
        this.searchData[k] = filters[k][0];
      }

      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
  },
  watch: {
    selected(val) {
      this.searchData.type = val.value;
    },
  },
};
</script>